export const CircleProgressConfig = {
  small: {
    circleSize: '40',
    valueFontSize: 10 as const,
  },
  medium: {
    circleSize: '64',
    valueFontSize: 16 as const,
  },
};

const CIRCLE_RADIUS = 20;

export const CIRCLE_CONFIG = {
  CIRCUMFERENCE: CIRCLE_RADIUS * 2 * Math.PI,
};
